
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7971c713\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?sourceMap!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./template.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!buble-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./template.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7971c713\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./template.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/routes/app/template.vue
// module id = 159
// module chunks = 1